module.exports = __webpack_public_path__ + "static/media/banner-img-contact-v2.fb611dd8.png";